(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3735);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1292:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/hero-banner-bg.dc0c0f4f.jpeg","height":575,"width":1400,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAZEAADAQEBAAAAAAAAAAAAAAAAARECEiH/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhEDEQA/AJfrT4t9SUAAMLX/2Q==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 9201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_geolocated__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4681);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9583);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6180);
/* harmony import */ var _public_assets_hero_banner_bg_jpeg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1292);
/* harmony import */ var _hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4493);
/* harmony import */ var _utils_firebase_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8201);










function HeroBanner(param) {
    var topComponent = param.topComponent, title = param.title, description = param.description, initialValues = param.initialValues, className = param.className;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var latitude = router.query.latitude;
    var longitude = router.query.longitude;
    var useHighContrast = (0,_hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_4__/* .useAccessibilitySettings */ .C)().useHighContrast;
    var getPosition = (0,react_geolocated__WEBPACK_IMPORTED_MODULE_6__/* .useGeolocated */ .E)({
        suppressLocationOnMount: true,
        onError: function(positionError) {
            alert("Sorry, it seems like we weren't able to get your location. Please check that you have location services enabled and try again.");
            console.error(positionError);
        },
        onSuccess: function(position) {
            router.push("/restaurants/search?latitude=".concat(position.coords.latitude, "&longitude=").concat(position.coords.longitude));
            (0,_utils_firebase_utils__WEBPACK_IMPORTED_MODULE_5__/* .logFirebaseEvent */ .Z)("click_near_me");
        }
    }).getPosition;
    var handleNearMeButtonClick = function() {
        getPosition();
    };
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(""), 2), searchTerm = ref[0], setSearchTerm = ref[1];
    var handleSearchTermChange = function(e) {
        setSearchTerm(e.target.value);
    };
    var handleFormSubmit = function(e) {
        e.preventDefault();
        if (latitude && longitude) {
            if (searchTerm) {
                router.push("/restaurants/search?searchTerm=".concat(searchTerm, "&latitude=").concat(latitude, "&longitude=").concat(longitude));
            } else {
                router.push("/restaurants/search?latitude=".concat(latitude, "&longitude=").concat(longitude));
            }
        } else if (searchTerm) {
            router.push("/restaurants/search?searchTerm=".concat(searchTerm));
        } else {
            router.push("/restaurants");
        }
        (0,_utils_firebase_utils__WEBPACK_IMPORTED_MODULE_5__/* .logFirebaseEvent */ .Z)("search_submit", {
            searchTerm: searchTerm
        });
    };
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
        if (initialValues === null || initialValues === void 0 ? void 0 : initialValues.searchTerm) {
            setSearchTerm(initialValues.searchTerm);
        } else {
            setSearchTerm("");
        }
    }, [
        initialValues
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_8__/* .twMerge */ .m)("pt-12 pb-28", useHighContrast ? "bg-contrast-yellow text-black" : "", className),
        style: {
            backgroundImage: useHighContrast ? "unset" : "url(".concat(_public_assets_hero_banner_bg_jpeg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src, ")"),
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center top",
            backgroundSize: "cover"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container flex flex-col items-center",
            children: [
                topComponent,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_8__/* .twMerge */ .m)("text-4xl font-medium text-center", useHighContrast ? "text-inherit" : "text-primary-500", description ? "mb-8" : null, topComponent ? "mt-4" : null),
                    children: title
                }),
                description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_8__/* .twMerge */ .m)("text-xl font-light text-center max-w-[760px]", useHighContrast ? "text-inherit" : "text-white"),
                    children: description
                }) : null,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                    onSubmit: handleFormSubmit,
                    className: "mt-14 w-full max-w-[1000px] flex flex-col space-y-4 lg:space-y-0 lg:flex-row lg:h-[58px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            onClick: handleNearMeButtonClick,
                            className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_8__/* .twMerge */ .m)("btn btn-xl rounded-[28px] px-10 h-[58px] lg:hidden", useHighContrast ? "btn-contrast-yellow" : "btn-primary", latitude && longitude ? "hidden" : null),
                            children: "Near me"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            type: "text",
                            id: "search-term",
                            name: "search-term",
                            placeholder: "Restaurant name or location",
                            "aria-label": "Restaurant name or location",
                            className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_8__/* .twMerge */ .m)("lg:flex-1 rounded-tr-[28px] rounded-br-[28px] lg:rounded-tr-none lg:rounded-br-none rounded-tl-[28px] rounded-bl-[28px] px-10 h-[58px] lg:h-full", useHighContrast ? "bg-contrast-yellow text-black border border-black placeholder:text-black" : null),
                            value: searchTerm,
                            onChange: handleSearchTermChange
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            type: "submit",
                            className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_8__/* .twMerge */ .m)("btn btn-xl rounded-[28px] lg:rounded-tl-none lg:rounded-bl-none lg:rounded-tr-[28px] lg:rounded-br-[28px] px-10 h-[58px] lg:h-full", useHighContrast ? "btn-contrast-yellow" : "btn-primary"),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_9__/* .FaSearch */ .U41, {
                                    className: "w-4 h-4 mr-2",
                                    "aria-hidden": "true"
                                }),
                                "Search"
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (HeroBanner);


/***/ }),

/***/ 3618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_SEO; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./config/site.config.ts
var siteConfig = Object.freeze({
    title: "GoodFoodTalks",
    description: "GoodFoodTalks",
    twitterCreator: "@GoodFoodTalks"
});

;// CONCATENATED MODULE: ./components/utils/SEO.tsx



function SEO(param) {
    var pageTitle = param.title, description = param.description, socialImageSrc = param.socialImageSrc;
    var siteTitle = siteConfig.title, siteDescription = siteConfig.description, twitterCreator = siteConfig.twitterCreator;
    var title = "".concat(pageTitle, " | ").concat(siteTitle);
    var metaDescription = description !== null && description !== void 0 ? description : siteDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:creator",
                content: twitterCreator
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:description",
                content: metaDescription
            }),
            socialImageSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: socialImageSrc
            }) : null
        ]
    });
}
/* harmony default export */ var utils_SEO = (SEO);


/***/ }),

/***/ 3735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(9583);
// EXTERNAL MODULE: ./node_modules/tailwind-merge/dist/lib/tw-merge.mjs + 11 modules
var tw_merge = __webpack_require__(6180);
;// CONCATENATED MODULE: ./public/assets/app-store-logo.svg
/* harmony default export */ var app_store_logo = ({"src":"/_next/static/media/app-store-logo.a2e763b8.svg","height":40,"width":120});
;// CONCATENATED MODULE: ./public/assets/gft-ios-nandos-menu-vertical.png
/* harmony default export */ var gft_ios_nandos_menu_vertical = ({"src":"/_next/static/media/gft-ios-nandos-menu-vertical.841bf354.png","height":1605,"width":1400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAATlBMVEXy8vHy5+MmNkAtNUAkMT1OWGHU09Pv7+4zQU8fLDvEv7vz6OexXgD//wD4+PcwO0n//v3d3+Gxm1zJvZGEXS6wnYytjnTWxLbk0NKuqaphGwQ1AAAADnRSTlP+/fzR6/r++vz9takoATgVHesAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA7SURBVHicBcEJAoAgCADB1VCwQ7C7/3+0GbblTc99sM5fvc4dyYVRE24GPZDmKIG4oaOTm3c0mKyoKj9NsAIa/nATWAAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/gft-ios-nandos-menu.png
/* harmony default export */ var gft_ios_nandos_menu = ({"src":"/_next/static/media/gft-ios-nandos-menu.f02040f4.png","height":909,"width":1400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAP1BMVEXx8O/TxZgyPUHe1NX9///n27q1oXsfLTzn3cpIU1+khl7/6MHw8O709vrWyL3f3+HVy8nX0rvZw6B4g4dLVWGC2hSnAAAADHRSTlPl/b37/v799/76/jWNhUUPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAMElEQVR4nB3BBw4AIAgEsHMgDhAc/3+riS1G8r6yOeKxWSdtcJNcSyDwFRFVBTd8DyTBAWbXsnFDAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/assets/gft-ios.png
/* harmony default export */ var gft_ios = ({"src":"/_next/static/media/gft-ios.cfcc85b5.png","height":6582,"width":3807,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAHlBMVEUgKjYeKjYnNkQbKTkvQVAkND5HWWMfLj4tO0s6TlmdbwdAAAAAB3RSTlPp3/7+/vL8nFJLHAAAAAlwSFlzAAAhOAAAITgBRZYxYAAAACtJREFUeJwdyLERADAIA7E3JgH2XzhHGhXiRKQ4c0dQNtBRWkOQ2ft/bOsBDZ0AhbJ2s94AAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/google-play-logo.png
/* harmony default export */ var google_play_logo = ({"src":"/_next/static/media/google-play-logo.7800a9e1.png","height":168,"width":564,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAHlBMVEUnJiIrKywtN0ZAQEAODg5SUlJEREQbGxs4RSVVNyGW49/SAAAABnRSTlP++fv+9P7A8nkKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNg4mBgZGBnZ2Fg4mRgY2VmYwQAAiIAPsmm1W4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./public/assets/logo-black.png
var logo_black = __webpack_require__(788);
// EXTERNAL MODULE: ./public/assets/logo.png
var logo = __webpack_require__(1334);
;// CONCATENATED MODULE: ./public/assets/affiliates/2.png
/* harmony default export */ var _2 = ({"src":"/_next/static/media/2.f52c33da.png","height":477,"width":1470,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEXSCyXOCyTSCiVMaXHOCyXOCiRvFiIiBgolAQUjEaSnAAAACXRSTlM7WU8AJHFjmIDeWZClAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHklEQVR4nGNgY4YABnYmRhYWBgYGBg4GViYmVkZGAAQZAEY/Qm5XAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/assets/affiliates/3.png
/* harmony default export */ var _3 = ({"src":"/_next/static/media/3.a8f3e5a2.png","height":290,"width":640,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAADFBMVEWTlZiTlZiTlZiTlZjrnGgCAAAABHRSTlMGF1NAaNvDtAAAAAlwSFlzAAALEwAACxMBAJqcGAAAACBJREFUeJwlycEJAAAMg0BN9t+5hPo6EECWaRIfHVD3DgJKACHQ9Rv3AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/assets/affiliates/4.jpg
/* harmony default export */ var _4 = ({"src":"/_next/static/media/4.4bd68317.jpg","height":395,"width":1101,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAfEAABAwMFAAAAAAAAAAAAAAARAAISAxMUAQQFYXL/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AqTuPo5165uZT0cMqrE+ZAdAIiIP/2Q==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/assets/affiliates/5.jpeg
/* harmony default export */ var _5 = ({"src":"/_next/static/media/5.72f479e5.jpeg","height":312,"width":771,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAbEAACAgMBAAAAAAAAAAAAAAAAEQITEhYxMv/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/8QAFxEBAAMAAAAAAAAAAAAAAAAAAAEhMf/aAAwDAQACEQMRAD8Aq6Y7Ng5q3tkn6XWwAXNYH//Z","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/assets/affiliates/6.png
/* harmony default export */ var _6 = ({"src":"/_next/static/media/6.6af8a024.png","height":155,"width":155,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEVMaXHYLC7gPzrfGyvHpVvEUzLWsG3iOz22cT/Kn1kECQqpAAAACnRSTlMARTgJsDo+MQpvx/F0HwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAACZJREFUeJxjYMAG2Dg5IAwWFhDJzMjEysjIxMDAzM7IxMjIiEULAAlXAD9jcZqIAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/affiliates/7.jpeg
/* harmony default export */ var _7 = ({"src":"/_next/static/media/7.f7478e38.jpeg","height":1831,"width":1831,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIDEQUSFTFR/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AKLx7BmC5r5iDJuRqK7uvUREH//Z","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./config/content.config.ts






var affiliateImages = [
    {
        img: _2,
        alt: "Nandos logo"
    },
    {
        img: _3,
        alt: "Cote Brasserie logo"
    },
    {
        img: _4,
        alt: "Fridays logo"
    },
    {
        img: _5,
        alt: "JD Wetherspoon logo"
    },
    {
        img: _6,
        alt: "Fullers logo"
    },
    {
        img: _7,
        alt: "Franca Manca logo"
    }, 
];
var statistics = [
    "Only 1% of blind people read Braille in the UK. That leaves almost 2 million who don't, so how do they manage in restaurants?",
    "87% rely on a dining companion or waiter to read them the menu for them when dining out.",
    "91% say browsing the menu themselves makes the dining more inclusive and enjoyable.", 
];

// EXTERNAL MODULE: ./hooks/useAccessibilitySettings.tsx
var useAccessibilitySettings = __webpack_require__(4493);
// EXTERNAL MODULE: ./components/Layout/index.ts + 7 modules
var Layout = __webpack_require__(1284);
// EXTERNAL MODULE: ./components/sections/HeroBanner.tsx
var HeroBanner = __webpack_require__(9201);
// EXTERNAL MODULE: ./components/utils/SEO.tsx + 1 modules
var SEO = __webpack_require__(3618);
;// CONCATENATED MODULE: ./pages/index.tsx

















var Home = function() {
    var useHighContrast = (0,useAccessibilitySettings/* useAccessibilitySettings */.C)().useHighContrast;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {
                title: "Home",
                description: "Home"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner/* default */.Z, {
                topComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: useHighContrast ? logo_black/* default */.Z : logo/* default */.Z,
                        alt: "goodfoodtalks header logo"
                    })
                }),
                title: "Opening menus for everybody",
                description: "GoodFoodTalks makes it easy for visually impaired diners to eat out at thousands of UK restaurants by providing accessible menus right here on our website and on our iPhone app."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (0,tw_merge/* twMerge */.m)("pt-20", useHighContrast ? "bg-contrast-yellow text-black" : "bg-[#fbfbee]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 lg:grid-cols-12 lg:gap-8 xl:gap-16",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg:col-span-7 xl:col-span-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pb-20",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-3xl text-[#15343c] pb-8",
                                            children: "Menus on the go. Download the GoodFoodTalks app today"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-xl font-light pb-8",
                                            children: "Take Goodfoodtalks with you on the move with our iOS mobile application, making the experience even more accessible and even more convenient. With over 5000 restaurants to choose from throughout the UK, you can independently browse the menu at your favourite restaurant (or request that they sign up if they arent already!)."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: "https://itunes.apple.com/gb/app/good-food-talks/id995331570?mt=8",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: app_store_logo,
                                                            alt: "Get Good Food Talks on the App Store",
                                                            width: "160px",
                                                            height: "54px"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "Get Good Food Talks on the App Store"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    href: "https://play.google.com/store/apps/details?id=uk.co.gearedapp.gft&gl=GB",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: google_play_logo,
                                                            alt: "Get Good Food Talks on Google Play",
                                                            width: "181px",
                                                            height: "54px"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "Get Good Food Talks on Google Play"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden lg:flex items-end lg:col-span-5 xl:col-span-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex-1 max-w-[90%] xl:max-w-[330px] 2xl:max-w-[330px] mx-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: gft_ios,
                                        alt: "Good Food Talks mobile app screenshots",
                                        layout: "responsive"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (0,tw_merge/* twMerge */.m)("py-6", useHighContrast ? "bg-contrast-yellow text-black" : "bg-[#ebeac8]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-[900px] xl:max-w-none mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col justify-center items-center sm:flex-row sm:flex-wrap gap-y-6 sm:space-x-10",
                        children: affiliateImages.map(function(affiliate) {
                            return(// eslint-disable-next-line @next/next/no-img-element
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: affiliate.img.src,
                                alt: affiliate.alt,
                                className: "h-[80px] md:h-[110px] lg:h-[120px] xl:h-[100px] 2xl:h-[130px] max-w-[140px] 2xl:max-w-[230px] object-contain"
                            }, "".concat(affiliate.img.src)));
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (0,tw_merge/* twMerge */.m)("relative pt-20 pb-20", useHighContrast ? "bg-contrast-yellow text-black" : "bg-[#fbfbee]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative 2xl:grid 2xl:grid-cols-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "md:max-w-[450px] xl:max-w-[620px] 2xl:max-w-[780px] pb-10 md:pb-0 2xl:flex 2xl:flex-col 2xl:justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-3xl text-[#15343c] pb-8",
                                            children: "Good Food Talks is making good food more accessible to everyone"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-xl font-light pb-8 md:max-w-[320px] 2md:max-w-[500px] lg:max-w-full",
                                            children: "Goodfoodtalks is a revolution in dining out for blind and visually impaired people throughout the UK. Regain your independence by browsing and listening to the menus at your favourite restaurants through a fully accessible website and mobile application."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            prefetch: false,
                                            href: "/restaurants",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: (0,tw_merge/* twMerge */.m)("btn btn-xl mt-8 flex sm:inline-flex items-center self-start", useHighContrast ? "btn-contrast-yellow" : "btn-primary"),
                                                children: [
                                                    "Browse restaurants",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaChevronRight */.Dli, {
                                                        className: "h-5 w-5 ml-4",
                                                        "aria-hidden": "true"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "hidden 2xl:flex justify-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative w-[580px] h-[480px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: gft_ios_nandos_menu,
                                            alt: "Good Food Talks mobile restaurant menu",
                                            layout: "fill",
                                            objectFit: "contain"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block 2xl:hidden relative md:absolute right-0 -bottom-10 xl:-bottom-20 w-full h-[300px] md:w-[340px] md:h-[380px] lg:w-[500px] lg:h-[520px] z-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: gft_ios_nandos_menu_vertical,
                            alt: "Good Food Talks mobile restaurant menu",
                            layout: "fill",
                            objectFit: "contain"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (0,tw_merge/* twMerge */.m)("relative pt-20 lg:pt-[124px] 2xl:pt-20 pb-20", useHighContrast ? "bg-contrast-yellow text-black" : "bg-[#f6f4df]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 gap-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-3xl text-[#15343c] pb-8",
                                        children: "A New Opportunity for Restaurant Owners"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-xl font-light pb-8",
                                        children: [
                                            "Good Food Talks is already trusted across more than 5000 venues by some of the UK’s leading restaurant chains. We can help you make your menu completely accessible for people with visual impairments and other reading difficulties for a low monthly fee. Click through to see more about the",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                prefetch: false,
                                                href: "/benefits",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (0,tw_merge/* twMerge */.m)(useHighContrast ? "link-contrast-underline" : "link-primary"),
                                                    children: "benefits for restaurant owners."
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        prefetch: false,
                                        href: "/benefits",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: (0,tw_merge/* twMerge */.m)("btn btn-xl mt-8 flex sm:inline-flex items-center self-start", useHighContrast ? "btn-contrast-yellow" : "btn-primary"),
                                            children: [
                                                "View benefits",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaChevronRight */.Dli, {
                                                    className: "h-5 w-5 ml-4",
                                                    "aria-hidden": "true"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "space-y-6 md:flex md:flex-col md:items-end",
                                    children: statistics.map(function(statistic, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: (0,tw_merge/* twMerge */.m)("p-6 border", useHighContrast ? "bg-contrast-yellow border-black" : "border-[#f1eec9] shadow-sm bg-white", index % 2 === 0 ? "md:max-w-[340px] lg:max-w-[430px] xl:max-w-[90%] 2xl:max-w-full" : "md:max-w-[270px] lg:max-w-[350px] xl:max-w-[80%] 2xl:max-w-[80%]"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "font-light text-center",
                                                children: statistic
                                            })
                                        }, statistic);
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,314,284,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);